import '@vfde-brix/offer-price/dist/styles.css';
import '@vfde-brix/button/dist/styles.css';
import '@vfde-brix/promo-price/dist/styles.css';
import '@vfde-brix/tooltip/dist/styles.css';
import '@vfde-brix/offer-price/dist/styles.css';
import '@vfde-brix/highlight-badge/dist/styles.css';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createOfferPriceComponent } from '@vfde-brix/offer-price';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-offer-price', createOfferPriceComponent, NO_PATTERN_BUSINESS_LOGIC);
